/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardStatsDto } from '../../models/dashboard-stats-dto';

export interface VolunteerStatsControllerGetDashboard$Params {
}

export function volunteerStatsControllerGetDashboard(http: HttpClient, rootUrl: string, params?: VolunteerStatsControllerGetDashboard$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardStatsDto>> {
  const rb = new RequestBuilder(rootUrl, volunteerStatsControllerGetDashboard.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DashboardStatsDto>;
    })
  );
}

volunteerStatsControllerGetDashboard.PATH = '/volunteer-stats/dashboard';
